import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { camelCase, startCase } from 'lodash';
import React from 'react';

const Ticket = ({ header, children, type = 'success', title, boxes, t }) => {
  const icons = {
    success: { prefix: 'fa', iconName: 'check-circle' },
    danger: { prefix: 'fa', iconName: 'exclamation-circle' },
    warning: { prefix: 'fa', iconName: 'exclamation-triangle' },
    primary: { prefix: 'fa', iconName: 'info-circle' }
  };

  const toastClasses = classNames('ticket-request', `ticket-request-${type}`);

  return (
    <div className={toastClasses}>
      <div className="ticket-top">
        <div className="ticket-icon">
          <FontAwesomeIcon icon={icons[type]} size="3x" />
        </div>
        { header && (
        <div className="ticket-header">
          {header}
        </div>
        )}
        { title && <div className="ticket-title">{title}</div> }
      </div>
      <div className="ticket-bottom">
        { boxes && (
        <div className="p-3">
          { Object.keys(boxes).map((v) => {
            return boxes[v] && (
            <div className="form-info" key={v}>
              <div className="text-left">{t(camelCase(`label${startCase(v)}`))}: </div>
              <div className="points" />
              <div className="text-right">
                {boxes[v]}
              </div>
            </div>
            );
          }) }
        </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Ticket;
